export function initCursor() {
  var cursor = document.getElementById('mj-cursor');
  if (!cursor || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var cx = 0, cy = 0, tx = 0, ty = 0;
  document.addEventListener('mousemove', function (e) {
    tx = e.clientX; ty = e.clientY;
    if (!cursor.classList.contains('is-visible')) cursor.classList.add('is-visible');
  });
  (function loop() {
    cx += (tx - cx) * 0.15;
    cy += (ty - cy) * 0.15;
    cursor.style.left = cx + 'px';
    cursor.style.top = cy + 'px';
    requestAnimationFrame(loop);
  })();

  document.querySelectorAll('a, button, .mj-card, .mj-btn').forEach(function (el) {
    el.addEventListener('mouseenter', function () { cursor.classList.add('is-hover'); });
    el.addEventListener('mouseleave', function () { cursor.classList.remove('is-hover'); });
  });
  document.addEventListener('mousedown', function () { cursor.classList.add('is-click'); });
  document.addEventListener('mouseup', function () { cursor.classList.remove('is-click'); });
}
